export type TrackingDeploymentMode = 'production' | 'debug' | 'disabled';

export const getTrackingDeploymentMode = (
  deploymentEnvironment?: string
): TrackingDeploymentMode => {
  const normalizedEnvironment = deploymentEnvironment?.toLowerCase();

  if (
    normalizedEnvironment === 'prod' ||
    normalizedEnvironment === 'production'
  ) {
    return 'production';
  }

  if (normalizedEnvironment === 'local') {
    return 'debug';
  }

  return 'disabled';
};
